export { default, type RootProps } from './Root';
